define('services/skillsService',[
    'lib/knockout',
    'lib/lodash4',
    'jquery',
    'services/apiCore'
], function (ko, _, $, apiCore) {
    'use strict';

    var BASE_URI = '/routing/skills';

    var skillsService = {
        getSkills: function(options) {
            options = _.assign({ pageSize: 25, pageNumber: 1 }, options);
            return apiCore.v2.get(BASE_URI, options);
        }
    };

    return skillsService;

});

